const config: Record<string, string> = {
  loginModUrl: "https://mimg.127.net/p/freemail/lib/hdurs/hdurs-0.1.3.js",
  plusModUrl: 'https://mimg.127.net/p/tools/mailplus-sdk/payUmd-0.0.28.beta.js',
  payUmdUrl: 'https://mimg.127.net/p/tools/plus-pay/plusActPay-0.0.6-beta2.js',
  loadingUrl: 'https://mail-activity.nos-jd.163yun.com/3bc5016c0dba8c2eca3dd210213f3d6f.gif',
};

export default config;
